
// HACK: node explodes when even referencing 'window' and 'document'. They aren't undefined as you would expect.
// So we detect node and return undefined in that case.

const isNode = () => {
    return typeof(window) === "undefined";
};

const getWindow = () => {
    if (isNode()) {
        return undefined;
    }
    return window;
};

const getDocument = () => {
    if (isNode()) {
        return undefined;
    }
    return document;
};

export function getDocumentHeight() {
    const doc = getDocument();

    if(doc === undefined)
        throw new Error("Document returned from getDocument is undefined.");

    return Math.max(
        doc.body.scrollHeight,
        doc.documentElement.scrollHeight,
        doc.body.offsetHeight,
        doc.documentElement.offsetHeight,
        doc.body.clientHeight,
        doc.documentElement.clientHeight
    );
}

// Exports global browser variables as module scoped variables
export default { window: getWindow(), document: getDocument() };
